import $ from 'jquery';
import common from './common';

import videoPlayerWidgetFactory from '../../Widgets/ui/VideoPlayer/factory';

export default function (options) {
  let { container } = options;

  common(options);

  $('video', container).each((n, videoElement) => {
    videoPlayerWidgetFactory.create(videoElement);
  });
}
